import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TransactionState {
  pendingCardIds: number[];
  pendingCustomerIds: number[];
}

const initialState: TransactionState = {
  pendingCardIds: [],
  pendingCustomerIds: [],
};

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    markCardAsPending: (state, action: PayloadAction<number>) => {
      if (!state.pendingCardIds.includes(action.payload)) {
        state.pendingCardIds.push(action.payload);
      }
    },
    markCustomerAsPending: (state, action: PayloadAction<number>) => {
      if (!state.pendingCustomerIds.includes(action.payload)) {
        state.pendingCustomerIds.push(action.payload);
      }
    },
    clearCardPending: (state, action: PayloadAction<number>) => {
      state.pendingCardIds = state.pendingCardIds.filter(
        (id) => id !== action.payload
      );
    },
    clearCustomerPending: (state, action: PayloadAction<number>) => {
      state.pendingCustomerIds = state.pendingCustomerIds.filter(
        (id) => id !== action.payload
      );
    },
  },
});

export const {
  markCardAsPending,
  markCustomerAsPending,
  clearCardPending,
  clearCustomerPending,
} = transactionSlice.actions;

export default transactionSlice.reducer;
